import type { ReactNode } from "react";
import TextCopy from "../../../components/common/TextCopy";

const FORWARDING_ADDRESS_TOKEN = "{forwardingAddress}";

const renderBold = (text: string, keyPrefix: string): ReactNode[] =>
  text.split(/\*\*(.+?)\*\*/g).map((part, index) =>
    // The capture group lands on every odd index, so those are the bold runs.
    index % 2 ? <strong key={`${keyPrefix}-${index}-${part}`}>{part}</strong> : part
  );

/**
 * Steps stay plain strings so the guides remain data, with `**…**` marking the parts the design shows
 * in bold — the UI labels a user has to find, such as **Settings** > **Mail** > **Rules**.
 */
export const renderRichStep = (step: string, forwardingAddress?: string | null, addressClassName?: string): ReactNode[] =>
  step.split(FORWARDING_ADDRESS_TOKEN).flatMap((part, index) => [
    ...(index > 0
      ? [forwardingAddress
        ? (
          <TextCopy
            key={`address-${index}`}
            iconOnlyFeedback
            text={forwardingAddress}
            ariaLabel="Copy Merito forwarding address"
            className={addressClassName}
          />
        )
        : "the Merito forwarding address"]
      : []),
    ...renderBold(part, String(index)),
  ]);
